import AbsModule from '../common/AbsModule';
import { lnbMarkup } from '../common/LnbCommon';
import { PURPLE_DEVICE } from '../common/const';

const $ = jQuery;

class Lnb extends AbsModule {
    constructor(_config) {
        super(_config);
        this.disabled = !$.isArray(_config.lnbData) || _config.lnbData.length === 0;

        this.isReady();
    }

    // fontface 구성 여부
    async isReady() {
        const readyResult = await document.fonts.ready || {};
        this.fontLoaded = readyResult.status === 'loaded';

        if(this.fontLoaded && this.active) {
            this.hoverBarMove(this.active.d1, this.active.d2);
        }
    }

    startSetting() {
        if (this.disabled) return;

        const {
            active = {},
            lnbCallbackMap
        } = this.moduleData;
        const isMain = !active.d1 && !active.d2;
        // console.log(active);
        let timeoutID = null;

        this.hoverBar = $('#nc-cnb .ncc-lnb-hover');
        this.hoverBarHalf = this.hoverBar.width() / 2;
        this.hoverBarPos = 50;
        this.active = active; // isReady에서 사용하기 위해

        if (isMain) {
            $('.ncc-lnb').addClass('ncc-lnb-type--main');
        }

        // onClick 콜백 실행
        $('#nc-cnb .ncc-lnb [data-callback]').on('click', e => {
            e.preventDefault();

            const target = e.currentTarget;
            const callbackKey = target?.dataset?.callback;
            const callback = lnbCallbackMap?.get(callbackKey);
            
            // callback 실행
            if(typeof callback === 'function') {
                callback(e);
            }

            return false;
        });

        // menu items
        $('#nc-cnb')
            .on('mouseenter', '.ncc-lnb .ncc-lnb-item', e => {
                if (isMain) {
                    $('.ncc-lnb').addClass('ncc-lnb-type--main-over');
                }
                const $target = $(e.currentTarget);
                const $lnbList = $target.closest('.ncc-lnb-list');

                $lnbList.find(`li.m${active.d1}`).removeClass('is-active');
                $target.addClass('is-over');

                if (timeoutID) {
                    clearTimeout(timeoutID);
                    timeoutID = null;
                }
                const targetIndex = $target.index() + 1;
                if (targetIndex === active.d1) {
                    this.hoverBarMove(targetIndex, active.d2);
                } else {
                    this.hoverBarMove(targetIndex);
                }
                return false;
            })
            .on('mouseleave', '.ncc-lnb .ncc-lnb-item', e => {
                if (isMain) {
                    $('.ncc-lnb').removeClass('ncc-lnb-type--main-over');
                }
                const $target = $(e.currentTarget);
                const $lnbList = $target.closest('.ncc-lnb-list');

                $target.removeClass('is-over');
                $lnbList.find(`li.m${active.d1}`).addClass('is-active');

                /*timeoutID = setTimeout(() => {
                  this.hoverBarMove(active.d1, active.d2);
                }, 100);*/
                return false;
            });

        // sub items
        $('#nc-cnb')
            .on('mouseenter', '.ncc-lnb .ncc-lnb-item .ncc-lnb-item__sub li', e => {
                const $target = $(e.currentTarget);
                const $lnbList = $target.closest('.ncc-lnb-list');
                const $activeTarget = $lnbList.find(`li.m${active.d1} .ncc-lnb-item__sub li.s${active.d2}`);

                $activeTarget.removeClass('is-active');
                $target.addClass('is-active');

                if (timeoutID) {
                    clearTimeout(timeoutID);
                    timeoutID = null;
                }
                this.hoverBarMove($target.closest('.ncc-lnb-item').index() + 1, $target.index() + 1);
                return false;
            })
            .on('mouseleave', '.ncc-lnb .ncc-lnb-item .ncc-lnb-item__sub li', e => {
                const $target = $(e.currentTarget);
                const $lnbList = $target.closest('.ncc-lnb-list');
                const $activeTarget = $lnbList.find(`li.m${active.d1} .ncc-lnb-item__sub li.s${active.d2}`);

                $target.removeClass('is-active');
                $activeTarget.addClass('is-active');

                timeoutID = setTimeout(() => {
                    this.hoverBarMove(active.d1, active.d2);
                }, 30);
                // return false;
            });

        this.hoverBarMove(active.d1, active.d2);
    }

    hoverBarMove(_d1 = 0, _d2 = 0) {
        if(!this.fontLoaded) { // 아직 font 로드 되지 않음
            return;
        }

        const el = $(`#nc-cnb .ncc-lnb .ncc-lnb-list li.m${_d1} .ncc-lnb-item__sub li.s${_d2}`);

        //const hoverBarScale = el.length ? (el.width() * 0.01 * 1.4).toFixed(2) : 0.1;
        const hoverBarScale = el.length ? (el.width() * 0.01 * 0.94).toFixed(2) : 0.1;
        const hoverBarOpacity = el.length ? 1 : 0;

        if (el.length && el.offset().left > 0) {
            const elCenterPos = el.offset().left + el.width() / 2;
            this.hoverBarPos = parseInt(elCenterPos - this.hoverBarHalf, 10) + 1;
        }

        if (this.hoverBar) {
            this.hoverBar.css({
                transform: `translateX(${this.hoverBarPos}px) scaleX(${hoverBarScale})`,
                opacity: hoverBarOpacity,
            });
        }
    }

    makeMarkup() {
        const { isPurple, purpleDevice } = this.com || {};
        const { lnbData, active } = this.moduleData || {};

        return `
        <nav class="ncc-lnb">
            ${lnbMarkup({
                lnbData, 
                isSub: false, 
                active,
                isPurple,
                isPurpleMobile: isPurple && purpleDevice === PURPLE_DEVICE.mobile
            })}
            <span class="ncc-lnb-hover"></span>
        </nav>`;
    }
}

export default Lnb;